export default {
  getInvoices: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/invoices/getters.js